"use client";

import { useTranslations } from "next-intl";
import { forwardRef } from "react";
import CloseIcon from "@/assets/icons/close.svg";
import InfoIcon from "@/assets/icons/info.svg";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useTopBanner } from "../hooks/top-banner.hook";

export const TopBannerInfo = forwardRef(
  (
    {
      uuid,
      text,
      onClose,
    }: { uuid: string; text: string; onClose: () => void },
    ref: React.Ref<HTMLDivElement>,
  ) => {
    const t = useTranslations("topBanners");
    const { show, handleClose } = useTopBanner({ uuid, text });

    return (
      <div
        className={cn("bg-brand-blue-light py-3 md:py-2", !show && "hidden")}
        data-uuid={uuid}
        ref={ref}
      >
        <div className="container flex items-start gap-x-3 font-medium text-base text-brand-blue leading-6 md:items-center md:gap-x-0">
          <div className="flex flex-1 items-start gap-x-2 md:items-center md:justify-center md:pl-2">
            <InfoIcon aria-hidden="true" className="shrink-0" />
            <p>{text}</p>
          </div>
          <Button
            aria-label={t("close")}
            className="size-6 min-h-6 shrink-0 p-0 md:-my-1.5 md:-mr-4 md:size-9"
            onClick={() => {
              handleClose(uuid, text);
              onClose();
            }}
            variant="ghost"
          >
            <CloseIcon className="text-brand-blue" />
          </Button>
        </div>
      </div>
    );
  },
);
